<template>
  <div class>
    <v-dialog v-model="dialog">
      <template v-slot:activator="{ on, attrs }">
        <v-layout justify-space-between>
          <v-chip label v-bind="attrs" v-on="on">
            <v-icon left>mdi-calendar</v-icon>
            {{ chipText }}
            <v-icon right>keyboard_arrow_right</v-icon>
          </v-chip>
        </v-layout>
      </template>
      <v-card>
        <v-card-title>{{$t('activities.details.timetable')}}</v-card-title>
        <v-card-text>
          <timetable :timetable="timetable"></timetable>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog=false">{{ $t('actions.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
    }
  },
  components: {
    Timetable: () =>
      import('@/components/view-components/activities/Timetable.vue'),
  },
  props: {
    chipText: String,
    timetable: Array,
  },
}
</script>
